module.exports = ".gain-image {\n    height: 100px;\n    -o-object-fit: contain;\n       object-fit: contain;\n    margin: 10px 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/gain/gain.component.css
// module id = ./src/app/shared/gain/gain.component.css
// module chunks = main